export default class AuthService {
    constructor(requestService) {
        this._requestService = requestService;
        this._API_BASE = `${requestService.apiBase}/auth`;
        this.jwtSuffix = process.env.NODE_ENV !== 'production' ? '-dev' : '';
    };

    isUserLoggedIn(successCallback, failureCallback) {
        this._requestService.oAuthGet(`${this._API_BASE}/current-user`, {},
            (response)=> {
                var data = response.data,
                    token = data.token,
                    user = data.user;

                user.dashboard_link = data.dashboard_link;

                successCallback(user);
                //TODO: TOKEN EXPIRY AND OAUTH HANDSHAKE
            }, (response)=> {
                failureCallback(response.data);
            });
    };

    login(email, password, rememberMe, token, successCallback, failureCallback) {
        this._requestService.oAuthPost(`${this._API_BASE}/login`, {
            'email_address': email,
            'password': password,
            'remember': rememberMe,
            token
        }, (response)=> {
            var data = response.data,
                token = data.token,
                user = data.user;

            user.dashboard_link = data.dashboard_link;

            if (data.jwt) {
                document.cookie = `client-jwt${this.jwtSuffix}=${data.jwt}; SameSite=None; Secure; path=/; domain=.viralstyle.com;`;
            }

            if (user.roles.includes('CLIENT')) {
                snaptr('track', 'LOGIN');
            }

            successCallback(user);
        }, (response)=> {
            failureCallback(response.data);
        });
    };

    logout(successCallback, failureCallback) {
        document.cookie = `client-jwt${this.jwtSuffix}=; path=/; SameSite=None; Secure; domain=.viralstyle.com; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

        this._requestService.oAuthGet(`${this._API_BASE}/logout`, {}, successCallback, failureCallback);
    };

    register(name, publicName, email, password, terms, refId, token, successCallback, failureCallback) {
        this._requestService.oAuthPost(`${this._API_BASE}/register`, {
            'full_name': name,
            'public_name': publicName,
            'email_address': email,
            'password': password,
            'accept_tos': terms,
            'ref_id': refId,
            token
        }, (response)=> {
            var data = response.data,
                token = data.token,
                user = data.user;

            fbq('track', 'CompleteRegistration');
            snaptr('track', 'SIGN_UP');

            successCallback(user);
        }, (response)=> {
            failureCallback(response.data);
        });
    };

    resetPasswordRequest(email, successCallback, failureCallback) {
        this._requestService.oAuthPost(`${this._API_BASE}/reset-password-request`, {
            'email_address': email
        }, successCallback, failureCallback);
    };

    resetPassword(password, token, successCallback, failureCallback) {
        this._requestService.oAuthPost(`${this._API_BASE}/reset-password`, {
            'password': password,
            'token': token
        }, successCallback, failureCallback);
    };

    verifyPublicName(publicName, successCallback, failureCallback) {
        this._requestService.oAuthGet(`${this._API_BASE}/validate-public-name?public_name=${publicName}`, {}
            , (response)=> {
                successCallback(response.data);
            }, (response)=> {
                failureCallback(response.data);
            });
    };

    verifyEmailAddress(email, successCallback, failureCallback) {
        this._requestService.oAuthGet(`${this._API_BASE}/validate-email?email_address=${email}`, {}, successCallback, failureCallback);
    };
}


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/services/AuthService.js